import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7d474436&scoped=true&lang=pug&"
import script from "./List.vue?vue&type=script&lang=coffee&"
export * from "./List.vue?vue&type=script&lang=coffee&"
import style0 from "./List.vue?vue&type=style&index=0&id=7d474436&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d474436",
  null
  
)

export default component.exports